import axios from 'axios'
import Header from './Component/Header';
import { useState } from 'react';
import { Toast } from './Component/Utils/general-function';
import Loader from './Component/Utils/Loader';


const Test2 = () => {
      const [searchtxt, setSearchtxt] = useState("");
      const [data, setData] = useState("");
      const [loading, setLoading] = useState(false);
    
      const OnChange = (e) => {
    setSearchtxt(e.target.value.toUpperCase());
  };

    const rcSearcFetch = async () => {
        if(!(searchtxt||"").trim() )return Toast(false,"","Please enter car number")
            setLoading(true)
        const res =await axios.post("https://api.dhboss.com/apicall/rto_vehicle_info/", {
        vehicleId: searchtxt,
        apikeyfill:"3lsSCR1jYyjBJAYndkNxo9vRKrFcEE21Zfkxou05nXf3UZTRkECGrCQ0Dhik0NZMjeRqPF"
    }, {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        //    "Content-Type": "application/json"
        }
    })
        if (res?.data?.status !== "success" || res?.data?.code !== 200) {
       setLoading(false)

    return Toast(false,"",res?.data?.message ||"Something went wrong!")
}
        console.log('res', res);
        setData(res?.data?.response)
       setLoading(false)
    
    }
     const handleNullValue = (value) => {
    return value === null || value === undefined || value === "" ? "-" : value;
  };
  return (
      <div>
          <Header />
           {loading ? <Loader /> : null}
          <div className="content">
               <div className="text-center">
          <h2 className="page-title">Rc search Demo</h2>
              </div>
         <div className="input-group mt-2">
          <input
            type="text"
            className="form-control"
            placeholder="RC Number"
            name="searchtxt"
            value={searchtxt}
            onChange={OnChange}
          />
          <button
            className="btn rc-submit"
            type="submit"
            onClick={rcSearcFetch}
          >
            Submit
          </button>
        </div>
              {/* Display the API response data */}
      {data && (
        <div style={{ backgroundColor: "white", borderRadius: "8px", padding: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
          <h3>Vehicle Information</h3>
          <div style={{display: 'flex',
gridTemplateColumns: '1fr 1fr',
gap: '7px',
                          flexDirection: 'column'
                      }}>
                          
          <div style={{   fontSize: "14px", color: "#333" }}><strong>RC Status:</strong> {handleNullValue(data.rcStatus)}</div>
                          <div style={{ fontSize: "14px", color: "#333" }}><strong>Registration Number:</strong> {handleNullValue(data.registration_No)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong>Registration Date:</strong> {handleNullValue(data.registration_date)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Owner Name:</strong> {handleNullValue(data.owner_Name)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Chassis Number:</strong> {handleNullValue(data.chassis_number)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Engine Number:</strong> {handleNullValue(data.engine_number)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Brand Name:</strong> {handleNullValue(data.brand_name)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Brand Model:</strong> {handleNullValue(data.brand_model)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Fuel Type:</strong> {handleNullValue(data.fuelType)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> RTO Code:</strong> {handleNullValue(data.rto_code)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Fitness Upto:</strong> {handleNullValue(data.fitnessUpto)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Financer:</strong> {handleNullValue(data.financer)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Financed:</strong> {handleNullValue(data.financed)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Insurance Company:</strong> {handleNullValue(data.insurance_company)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Insurance Policy:</strong> {handleNullValue(data.insurance_policy)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Insurance Expiry:</strong> {handleNullValue(data.insurance_expiry)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Manufacturing Date:</strong> {handleNullValue(data.manufacturingDate)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Registering Authority:</strong> {handleNullValue(data.registeringAuthority)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Road Tax Paid Upto:</strong> {handleNullValue(data.roadTaxPaidUpto)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Seat Capacity:</strong> {handleNullValue(data.seat_capacity)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Cubic Capacity:</strong> {handleNullValue(data.cubic_capacity)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Vehicle Class:</strong> {handleNullValue(data.vehicleClass)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Pucc Upto:</strong> {handleNullValue(data.puccUpto)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Permit Validity:</strong> {handleNullValue(data.permitValidity)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#333" }}><strong> Permit Type:</strong> {handleNullValue(data.permittype)}</div>
                          
                          <div style={{ fontSize: "14px", color: "#020202" }}><strong> Norms Type:</strong> {handleNullValue(data.normsType)}</div>
                          
            <div style={{   fontSize: "14px", color: "#333" }}><strong> Body Type:</strong> {handleNullValue(data.bodyType)}</div>
           
          </div>
        </div>
      )}
            </div>
        
      </div>
      
  )
}

export default Test2